import { workflowConstants } from '../constants'
import { workflowRequests } from '../../services'
import { handleErrorMessage } from '../../utils'

export const workflowActions = {}

workflowActions.GetResourceData = (pdfName) => {
  return dispatch => {
    dispatch(request())
    workflowRequests.GetResourceData(pdfName)
      .then(
        workflowData => dispatch(success(workflowData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: workflowConstants.WORKFLOW_RES_REQUEST }
  }

  function success(workflowData) {
    return { type: workflowConstants.WORKFLOW_RES_SUCCESS, workflowData }
  }

  function failure(error) {
    return { type: workflowConstants.WORKFLOW_RES_FAILURE, error }
  }
}

workflowActions.GetWorkflowDefinitions = (data) => {
  return dispatch => {
    dispatch(request())
    workflowRequests.GetWorkflowDefinitions(data)
      .then(
        workflowDefinitionsData => dispatch(success(workflowDefinitionsData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: workflowConstants.WORKFLOW_REQUEST }
  }

  function success(workflowData) {
    return { type: workflowConstants.WORKFLOW_SUCCESS, workflowData }
  }

  function failure(error) {
    return { type: workflowConstants.WORKFLOW_FAILURE, error }
  }
}

workflowActions.ContinueWorkflowAction = (data, isReset = false) => {
  return dispatch => {
    if (isReset) {
      dispatch(reset())
    } else {
      dispatch(request())
      workflowRequests.ContinueWorkflow(data)
        .then(
          continueWorkflow => dispatch(success(continueWorkflow)),
          error => dispatch(failure(handleErrorMessage(error)))
        )
    }
  }

  function request() {
    return { type: workflowConstants.CONTINUE_WORKFLOW_REQUEST }
  }

  function success(workflowData) {
    return { type: workflowConstants.CONTINUE_WORKFLOW_SUCCESS, workflowData }
  }

  function failure(error) {
    return { type: workflowConstants.CONTINUE_WORKFLOW_FAILURE, error }
  }
  
  function reset() {
    return { type: workflowConstants.CONTINUE_WORKFLOW_RESET }
  }
}

workflowActions.CancelWorkFlow = (data) => {
  return dispatch => {
    dispatch(request())
    workflowRequests.CancelWorkFlow(data)
      .then(
        cancelWFData => dispatch(success(cancelWFData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: workflowConstants.CANCEL_WORKFLOW_REQUEST }
  }

  function success(cancelWFData) {
    return { type: workflowConstants.CANCEL_WORKFLOW_SUCCESS, cancelWFData }
  }

  function failure(error) {
    return { type: workflowConstants.CANCEL_WORKFLOW_FAILURE, error }
  }
}

workflowActions.GetWorkFlowDefinition = (data) => {
  return dispatch => {
    dispatch(request())
    workflowRequests.GetWorkFlowDefinition(data)
      .then(
        workflowDefinitionData => dispatch(success(workflowDefinitionData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: workflowConstants.WORKFLOW_DEFINICION_REQUEST }
  }

  function success(workflowDefinicionData) {
    return { type: workflowConstants.WORKFLOW_DEFINICION_SUCCESS, workflowDefinicionData }
  }

  function failure(error) {
    return { type: workflowConstants.WORKFLOW_DEFINICION_FAILURE, error }
  }
}

workflowActions.GetBinnacle = (data) => {
  return dispatch => {
    dispatch(request())
    workflowRequests.GetBinnacle(data)
      .then(
        binnacleData => dispatch(success(binnacleData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: workflowConstants.GET_BINNACLE_REQUEST }
  }

  function success(binnacleData) {
    return { type: workflowConstants.GET_BINNACLE_SUCCESS, binnacleData }
  }

  function failure(error) {
    return { type: workflowConstants.GET_BINNACLE_FAILURE, error }
  }
}

workflowActions.RegisterStatusStage = (data) => {
  return dispatch => {
    dispatch(request())
    workflowRequests.RegisterStatusStage(data)
      .then(
        regStatusStage => dispatch(success(regStatusStage)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: workflowConstants.REG_STATUSSTAGE_REQUEST }
  }

  function success(regStatusStage) {
    return { type: workflowConstants.REG_STATUSSTAGE_SUCCESS, regStatusStage }
  }

  function failure(error) {
    return { type: workflowConstants.REG_STATUSSTAGE_FAILURE, error }
  }
}